export default function (number) {
  return Math.round((parseFloat(number) + Number.EPSILON) * 100) / 100
}